module.exports = __webpack_public_path__ + "img/announcement.0adbe6bb.svg";